import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/components/SwitchProject/ProjectBadge/FolderIcon.styled.ts";

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { FolderWithoutSubstrate } from '@gmini/ui-kit';
import styled from 'styled-components';
export var Folder = styled(FolderWithoutSubstrate)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  && {\n    width: 20px;\n    min-width: 20px;\n    height: 20px;\n\n    & path {\n      opacity: 1;\n      fill: #353b60;\n    }\n  }\n"])));